import { ADMINISTRATION, COUNT, LINKING, LIST } from './common';

const DATASOURCE_CONFIGS = 'datasourceConfigs';

export const datasourceConfigQueryKeys = {
    all: [DATASOURCE_CONFIGS],
    count: [DATASOURCE_CONFIGS, COUNT],
    list: [DATASOURCE_CONFIGS, LIST],
    detail: (id: string | undefined) => [DATASOURCE_CONFIGS, id ?? 'unknown'],
    forAdministration: [DATASOURCE_CONFIGS, ADMINISTRATION],
    forLinking: [DATASOURCE_CONFIGS, LINKING],
    forWorkspace: (workspaceId: string) => [DATASOURCE_CONFIGS, workspaceId],
    importDefinitions: (configId: string) => [DATASOURCE_CONFIGS, configId, 'importDefinitions']
};
